import script from "./DutchAuctionStats.vue?vue&type=script&setup=true&lang=js"
export * from "./DutchAuctionStats.vue?vue&type=script&setup=true&lang=js"

import "./DutchAuctionStats.vue?vue&type=style&index=0&id=4ca8e434&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca8e434"]])

export default __exports__